/*******************************************************************************
PERFORM ACTIONS
Perform the action(s) associated with the selected tab.
*******************************************************************************/

/* global $$ */
export default function switchTab(tabSettings) {
    const { targets, add, remove } = tabSettings;

    // Loop through the targets and their associated actions
    for (let i = 0; i < targets.length; i++) {
        if (typeof targets[i] !== 'undefined') {
            const $target = $(targets[i]);
            if (typeof remove[i] !== 'undefined') { $target.removeClass(remove[i]); }
            if (typeof add[i] !== 'undefined') { $target.addClass(add[i]); }
            if ($target.find('.webix_dtable').length > 0 && typeof $$ !== 'undefined') {
                $$($target.find('.webix_dtable').attr('id')).resize();
            }
        }
    }
}
